import { lodashDeepClone, merge } from 'utils'

import { useCloudComputingPower } from 'store'
import { default as ico, default as simpleLogo } from '../../assets/image/88/favicon.png'
import bannerRightEn from '../../assets/image/88/home/banner-right-en.png'
import bannerRightZh from '../../assets/image/88/home/banner-right-zh.png'
import downloadBgEn from '../../assets/image/88/home/support-platform/download-en.png'
import downloadBgZh from '../../assets/image/88/home/support-platform/download-zh.png'
import logo from '../../assets/image/88/logo.png'
import { BaseConfig, type BaseConfigSource } from '../common-config'

/** 海报相关 --- start */
import cnPoster1 from '../../assets/image/88/poster/zh_CN/1.png'
import cnPoster2 from '../../assets/image/88/poster/zh_CN/2.png'
import cnPoster3 from '../../assets/image/88/poster/zh_CN/3.png'
import cnBanner from '../../assets/image/88/poster/zh_CN/banner.png'

import enPoster1 from '../../assets/image/88/poster/en/1.png'
import enPoster2 from '../../assets/image/88/poster/en/2.png'
import enPoster3 from '../../assets/image/88/poster/en/3.png'
import enBanner from '../../assets/image/88/poster/en/banner.png'
import { debitCard } from './common'
/** 海报相关 --- end */

const primary = '#F7B239'

const lightPrimary = '#D5A35D'

const secondaryPrimary = '#E81B40'

const tertiaryPrimary = '#8B1A1A'

const textColor = '#151519'

const primaryGradient = 'linear-gradient(270deg, #EECA7D 0%, #D5A35D 100%)'

/** 88配置 */
export const E88LightConfig = merge<BaseConfigSource, PlatformConfig>(lodashDeepClone(BaseConfig), {
  themeType: 'dark', // only dark
  logo: logo,

  simpleLogo,
  footerLogo: logo,
  platformName: '88',
  loginShowDownload: true,
  colors: {
    lightPrimary: lightPrimary,
    primaryGradient: primaryGradient,
    hoverPrimary: '#151519',

    zero: '#C2C7D0',
    status: {
      error: '#E81B40',
      success: '#28BA97',
      ing: '#3C53FF',
    },

    // 根据最新的UI提供的色值库的颜色
    primary,
    secondaryPrimary,
    tertiaryPrimary,
    error: '#FC495C',
    warning: '#FF8A00',
    success: '#00D391',
    link: '#4B5BE7',

    text: {
      base: '#151519',
      reverse: '#fff',
      primaryAlt: '#151519',
      secondary: '#75777A',
      tertiary: '#A0A3A7',
      quaternary: '#75777A',
      hover: '#151519',
    },
    bg: {
      base: '#FFFFFF',
      reverse: '#151519',
      secondary: '#FFFFFF',
      hover: '#EAECEF4C',
      tertiary: '#f7f7f9',
      icon: {
        primary: '#151519',
        secondary: '#75777A',
        trigger: '#E3E3E3',
        quaternary: '#8E9196',
      },
      button: {
        base: primary,
        primary: primary,
        primaryTextColor: textColor,
        disabledTextColor: '#fff',
        aux: '#F6F7F9',
        disabled: '#C2C7D0',
      },
      tag: {
        base: '#F3F4F6',
      },
      form: {
        base: '#F7F7F9',
        input: '#F7F7F9',
        modal: '#F1F3F6',
        card: '#ffffff',
      },
      mainPage: {
        base: '#FFFFFF',
        card: '#F5F5F7',
        actionBar: '#f3f4f6',
      },
      modal: {
        base: '#FFFFFF',
        card: '#ffffff',
        shadow: 'rgba(224, 227, 237, 0.9)',
      },
    },
    tip: '#F6F7F9',
    cardBorder: '#EAEAED',
    divider: '#EAECEF',
    borderSelected: '#74777B',
    sliderMenu: '#F4F5F6',
  },
  ico,
  header: {
    color: '#151519',
    // boxShadow: '0 1px 10px rgba(0, 0, 0, 0.11)',
    background: '#fff',
    aColor: '#151519',
    regBtnBgColor: '#FFFF38', // 注册按钮背景
    regTextColor: '#10151F', // 注册按钮文字颜色
    downloadTextColor: '#151519',
    activeColor: '#151519',
  } as PlatformConfig['header'],
  home: {
    banner: {
      bannerRight: {
        zh: bannerRightZh,
        en: bannerRightEn,
      },
    },
    supportPlatform: {
      appStore: false,
      downloadBg: {
        zh: downloadBgZh,
        en: downloadBgEn,
      },
    },
  },

  loadExternalConfig() {
    return useCloudComputingPower().loadExternalConfig()
  },
  debitCard: debitCard,
  cloud: {
    colors: {
      bg: {
        card: {
          primary: '#F3F4F6',
          fontColor: '#151519',
        },
      },
    },
  },
  posterConf: {
    zh_CN: {
      poster1: cnPoster1,
      poster2: cnPoster2,
      poster3: cnPoster3,
      banner: cnBanner,
    },
    en: {
      poster1: enPoster1,
      poster2: enPoster2,
      poster3: enPoster3,
      banner: enBanner,
    },
  },
} as BaseConfigSource as PlatformConfig)
